import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star"]

  updateStars(event) {
    const rating = parseInt(event.target.value)
    const stars = this.element.querySelectorAll("svg")

    stars.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-yellow-400")
      } else {
        star.classList.remove("text-yellow-400")
        star.classList.add("text-gray-300")
      }
    })
  }
}
